import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { UserContext } from '../login/LoginForm';
import { AuthContext } from '../login/AuthContext';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import ReportModal from '../reportForm/ReportModal';
import EditProfilForm from './EditProfilForm';
import UserPreferences from "./UserPreferences";

import { handleReportSubmit } from '../reportUtils';
import PrivacySettings from './PrivacySettings';
import TradingPreference from './TradingPreferences';
import ShippingPreference from './ShippingPreferences';
import ReportTheApp from '../reportForm/ReportTheApp';
import ReportFromFullPageListing from '../reportForm/ReportFromFullPageListing';
import translations from '../../utils/language/translations.json'
import { useTranslation } from 'react-i18next';
const ProfilChoice = () => {
  
  const [showMenu, setShowMenu] = useState(true);
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.ProfilChoice[key][currentLang]; // Adjust the path according to your JSON structure
 
  const [errorMessage, setErrorMessage] = useState('');
  
  const { userId,liveCsrfToken } = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const [selectedComponent, setSelectedComponent] = useState(isMobile===true?"":"EditProfil");
  const [isLoading, setIsLoading] = useState(true);


  // Fonction pour déterminer si le bouton est actif
  const isActive = (componentName) => {
    return selectedComponent === componentName ? 'active' : '';
  };

  const handleSelectComponent = (componentName) => {
    setSelectedComponent(componentName);
    if (isMobile) {
      setShowMenu(false); // Hide menu on mobile
    }
  };
 

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (userId !== undefined) {
      setIsLoading(false);
    }
  }, [userId]);
  useEffect(() => {
    if (userId === null) {
      console.log('Redirecting to login due to missing userId');
      navigate('/login');
    }
  }, [userId, navigate]);

  if (isLoading) {
    return <p>Loading...</p>;
  }

//   return (
//     <>
    
//         <section className='settingspages'>
//           <div className="contentfront">
//           {showMenu ? (
//             <div className="sousmenu verti">
//               <button onClick={() => handleSelectComponent('EditProfil')} className={isActive('EditProfil')}>{t('Edit Profil details')}</button>
//               {/* <button onClick={() => handleSelectComponent('ModifyPassword')} className={isActive('ModifyPassword')}>{t('Edit Profil details')}Edit password</button>
//               <button onClick={() => handleSelectComponent('ModifyEmail')} className={isActive('ModifyEmail')}>Edit my link</button>*/}
//               <button onClick={() => handleSelectComponent('ShippingPreference')} className={isActive('ShippingPreference')}>{t('Edit or create new Template for shipping')}</button> 
//               <button onClick={() => handleSelectComponent('TradingPreference')} className={isActive('TradingPreference')}>{t('Edit or create new template for trading')}</button>
//               <button onClick={() => handleSelectComponent('PrivacySettings')} className={isActive('PrivacySettings')}>{t('Privacy Setting')}</button>
//               <button onClick={() => handleSelectComponent('ReportTheApp')} className={isActive('ReportTheApp')}>{t('Report Issue')}</button>
            
             
//             </div>
//               ) : null}
//  {!showMenu || isMobile ? (
//     <div className="selectcontenu">
//       {!showMenu && (
//         <button className="back-button" onClick={() => setShowMenu(true)}>
//           ← {t('Back')}
//         </button>
//       )}
//       {selectedComponent === 'EditProfil' && <EditProfilForm />}
//       {selectedComponent === 'TradingPreference' && <TradingPreference />}
//       {selectedComponent === 'ShippingPreference' && <ShippingPreference />}
//       {selectedComponent === 'PrivacySettings' && <PrivacySettings />}
//       {selectedComponent === 'ReportTheApp' && (
//         <ReportTheApp userId={userId} liveCsrfToken={liveCsrfToken} />
//       )}
//     </div>
//   ) : null}
// </div>
          
//         </section>
     
//     </>
//   );
return (
  <section className="settingspages">
    <div className="contentfront">
      {isMobile ? (
        showMenu ? (
        <div className="sousmenuSetting verti" role="tablist" aria-label="Settings sections">
  <button
    type="button"
    className={`menu-item ${isActive('EditProfil')}`}
    aria-current={selectedComponent === 'EditProfil' ? 'page' : undefined}
    onClick={() => handleSelectComponent('EditProfil')}
  >
    <span className="mi icon-profile" aria-hidden="true" />
    {t('Edit Profil details')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('ShippingPreference')}`}
    aria-current={selectedComponent === 'ShippingPreference' ? 'page' : undefined}
    onClick={() => handleSelectComponent('ShippingPreference')}
  >
    <span className="mi icon-shipping" aria-hidden="true" />
    {t('Edit or create new Template for shipping')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('TradingPreference')}`}
    aria-current={selectedComponent === 'TradingPreference' ? 'page' : undefined}
    onClick={() => handleSelectComponent('TradingPreference')}
  >
    <span className="mi icon-trade" aria-hidden="true" />
    {t('Edit or create new template for trading')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('PrivacySettings')}`}
    aria-current={selectedComponent === 'PrivacySettings' ? 'page' : undefined}
    onClick={() => handleSelectComponent('PrivacySettings')}
  >
    <span className="mi icon-privacy" aria-hidden="true" />
    {t('Privacy Setting')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('ReportTheApp')}`}
    aria-current={selectedComponent === 'ReportTheApp' ? 'page' : undefined}
    onClick={() => handleSelectComponent('ReportTheApp')}
  >
    <span className="mi icon-bug" aria-hidden="true" />
    {t('Report Issue')}
  </button>
</div>


        ) : (
          <div className="selectcontenu">
            <button className="btn-ghost" onClick={() => setShowMenu(true)}>
              ← {t('Back')}
            </button>
            {selectedComponent === 'EditProfil' && <EditProfilForm />}
            {selectedComponent === 'TradingPreference' && <TradingPreference />}
            {selectedComponent === 'ShippingPreference' && <ShippingPreference />}
            {selectedComponent === 'PrivacySettings' && <PrivacySettings />}
            {selectedComponent === 'ReportTheApp' && (
              <ReportTheApp userId={userId} liveCsrfToken={liveCsrfToken} />
            )}
            {selectedComponent === 'UserPreferences' && <UserPreferences />}

          </div>
        )
      ) : (
        // Desktop layout: show both side by side
        <>
 <div className="sousmenuSetting verti" role="tablist" aria-label="Settings sections">
  <button
    type="button"
    className={`menu-item ${isActive('EditProfil')}`}
    aria-current={selectedComponent === 'EditProfil' ? 'page' : undefined}
    onClick={() => handleSelectComponent('EditProfil')}
  >
    <span className="mi icon-profile" aria-hidden="true" />
    {t('Edit Profil details')}
  </button>

<button
  type="button"
  className={`menu-item ${isActive('UserPreferences')}`}
  aria-current={selectedComponent === 'UserPreferences' ? 'page' : undefined}
  onClick={() => handleSelectComponent('UserPreferences')}
>
  <span className="mi icon-settings" aria-hidden="true" />
  {t('User preferences')}
</button>

  <button
    type="button"
    className={`menu-item ${isActive('ShippingPreference')}`}
    aria-current={selectedComponent === 'ShippingPreference' ? 'page' : undefined}
    onClick={() => handleSelectComponent('ShippingPreference')}
  >
    <span className="mi icon-shipping" aria-hidden="true" />
    {t('Edit or create new Template for shipping')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('TradingPreference')}`}
    aria-current={selectedComponent === 'TradingPreference' ? 'page' : undefined}
    onClick={() => handleSelectComponent('TradingPreference')}
  >
    <span className="mi icon-trade" aria-hidden="true" />
    {t('Edit or create new template for trading')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('PrivacySettings')}`}
    aria-current={selectedComponent === 'PrivacySettings' ? 'page' : undefined}
    onClick={() => handleSelectComponent('PrivacySettings')}
  >
    <span className="mi icon-privacy" aria-hidden="true" />
    {t('Privacy Setting')}
  </button>

  <button
    type="button"
    className={`menu-item ${isActive('ReportTheApp')}`}
    aria-current={selectedComponent === 'ReportTheApp' ? 'page' : undefined}
    onClick={() => handleSelectComponent('ReportTheApp')}
  >
    <span className="mi icon-bug" aria-hidden="true" />
    {t('Report Issue')}
  </button>
</div>


          <div className="selectcontenu">
            {selectedComponent === 'EditProfil' && <EditProfilForm />}
            {selectedComponent === 'TradingPreference' && <TradingPreference />}
            {selectedComponent === 'ShippingPreference' && <ShippingPreference />}
            {selectedComponent === 'PrivacySettings' && <PrivacySettings />}
            {selectedComponent === 'ReportTheApp' && (
              <ReportTheApp userId={userId} liveCsrfToken={liveCsrfToken} />
            )}
            {selectedComponent === 'UserPreferences' && <UserPreferences />}

          </div>
        </>
      )}
    </div>
  </section>
);

}








export default ProfilChoice